class ContainerService {
  container = null;

  appendComponent(component) {
    this.appendContainer();

    component.$mount(this.#getContainer());
  }

  removeComponent(component) {
    this.removeContainer();

    component.$destroy();
    component.$el.remove();
  }

  appendContainer() {
    document.body.append(this.#getContainer());
  }

  removeContainer() {
    this.container.remove();
  }

  #getContainer() {
    if (!this.container) {
      this.#createContainer();
    }

    return this.container;
  }

  #createContainer() {
    this.container = document.createElement('div');
  }
}

export default new ContainerService();
